(function () {
    window.JN = window.JN || {};

    var GROUPS = ['interpretations', 'places', 'topics', 'people', 'outlets', 'languages', 'skills'];
    var GROUPS_INTERPRETED = ['interpretations', 'topics', 'places', 'people', 'outlets', 'languages', 'skills'];
    var seq = 0;

    function groupLabel(group) {
        if (group === 'places') return window.JN.t('js.search2.group_places');
        if (group === 'topics') return window.JN.t('js.search2.group_topics');
        if (group === 'people') return window.JN.t('js.search2.group_people');
        if (group === 'outlets') return window.JN.t('js.search2.group_outlets');
        if (group === 'languages') return window.JN.t('js.search2.group_languages');
        return window.JN.t('js.search2.group_skills');
    }

    var TYPE_ICONS = {
        combo: 'ph:magnifying-glass', place: 'ph:map-pin', topic: 'ph:tag',
        outlet: 'ph:newspaper', speaks: 'ph:translate', skill: 'ph:graduation-cap',
        person: 'ph:user'
    };

    function debounce(fn, ms) {
        var timer;
        return function () {
            var args = arguments, ctx = this;
            clearTimeout(timer);
            timer = setTimeout(function () { fn.apply(ctx, args); }, ms);
        };
    }

    function esc(text) {
        var div = document.createElement('div');
        div.textContent = text == null ? '' : String(text);
        return div.innerHTML;
    }

    function itemPayload(group, item) {
        if (group === 'interpretations') {
            var params = {};
            if (item.q) params.q = item.q;
            if (item.profession_id) params.profession = String(item.profession_id);
            if (item.place) params.place = item.place;
            var parts = [item.profession_tx || item.q, item.place].filter(Boolean);
            return {type: 'combo', params: params, label: parts.join(' · '), parts: parts};
        }
        if (group === 'places') return {type: 'place', value: item.name, label: item.name};
        if (group === 'topics') return {type: 'topic', value: item.name, label: item.name};
        if (group === 'outlets') return {type: 'outlet', value: item.name, label: item.name};
        if (group === 'languages') return {type: 'speaks', value: item.cd, label: item.name};
        if (group === 'skills') return {type: 'skill', value: String(item.id), label: item.name};
        return {type: 'person', value: item.user_url, label: item.display_name};
    }

    function init(root) {
        // /search loads this bundle twice for signed-in users (header + page)
        if (root.dataset.omniboxWired) return;
        var input = root.querySelector('[data-omnibox-input]');
        var panel = root.querySelector('[data-omnibox-panel]');
        var submit = root.querySelector('[data-omnibox-submit]');
        if (!input || !panel) return;
        root.dataset.omniboxWired = '1';

        var navigate = root.hasAttribute('data-omnibox-navigate');
        var uid = 'omnibox-' + (seq++);
        var active = -1;
        var payloads = [];

        var examples = root.querySelector('[data-omnibox-examples]');
        if (examples) {
            try {
                var pool = JSON.parse(examples.textContent);
                if (pool.length) input.placeholder = pool[Math.floor(Math.random() * pool.length)];
            } catch (e) { /* keep the static placeholder */ }
        }

        input.setAttribute('role', 'combobox');
        input.setAttribute('aria-autocomplete', 'list');
        input.setAttribute('aria-expanded', 'false');
        panel.id = panel.id || uid + '-listbox';
        input.setAttribute('aria-controls', panel.id);
        panel.setAttribute('role', 'listbox');

        function options() { return panel.querySelectorAll('[role="option"]'); }

        function setActive(idx) {
            var opts = options();
            if (!opts.length) { active = -1; input.removeAttribute('aria-activedescendant'); return; }
            if (idx < 0) idx = opts.length - 1;
            if (idx >= opts.length) idx = 0;
            active = idx;
            opts.forEach(function (opt, i) {
                var on = i === active;
                opt.setAttribute('aria-selected', on ? 'true' : 'false');
                opt.classList.toggle('tw-bg-brand-50', on);
                if (on) {
                    input.setAttribute('aria-activedescendant', opt.id);
                    opt.scrollIntoView({block: 'nearest'});
                }
            });
        }

        function hide() {
            panel.classList.add('tw-hidden');
            panel.innerHTML = '';
            payloads = [];
            active = -1;
            input.setAttribute('aria-expanded', 'false');
            input.removeAttribute('aria-activedescendant');
        }

        function emit(payload) {
            if (payload.type === 'person') { window.location.href = payload.value; return; }
            if (navigate) {
                var params = new URLSearchParams();
                if (payload.type === 'combo') {
                    Object.keys(payload.params).forEach(function (k) { params.set(k, payload.params[k]); });
                } else {
                    params.set(payload.type, payload.value);
                }
                // keep the hero form's hidden fields (lang, src) that a native submit would send
                root.querySelectorAll('input[type="hidden"]').forEach(function (h) {
                    if (h.name && h.value && !params.has(h.name)) params.set(h.name, h.value);
                });
                window.location.href = '/search?' + params.toString();
                return;
            }
            root.dispatchEvent(new CustomEvent('jn:chip', {detail: payload}));
            input.value = '';
            hide();
            input.focus();
        }

        function submitTerm() {
            var term = input.value.trim();
            if (term) emit({type: 'q', value: term, label: term});
        }

        function render(data) {
            var html = '';
            payloads = [];
            var order = (data.interpretations && data.interpretations.length) ? GROUPS_INTERPRETED : GROUPS;
            order.forEach(function (group) {
                var items = data[group] || [];
                if (!items.length) return;
                if (group !== 'interpretations') {
                    html += '<div class="tw-px-2 tw-pt-2 tw-pb-1 tw-text-xs tw-text-tertiary" role="presentation">' + esc(groupLabel(group)) + '</div>';
                }
                items.forEach(function (item) {
                    var payload = itemPayload(group, item);
                    var icon = TYPE_ICONS[payload.type];
                    var body;
                    if (payload.type === 'combo') {
                        body = '<span class="tw-flex tw-items-center tw-gap-1.5 tw-min-w-0">' +
                            payload.parts.map(function (part) {
                                return '<span class="tw-inline-flex tw-items-center tw-bg-brand-100 tw-text-brand-700 tw-rounded-full tw-px-2 tw-py-0.5 tw-text-sm tw-truncate">' + esc(part) + '</span>';
                            }).join('') + '</span>';
                    } else if (group === 'people' && item.line) {
                        body = window.JN.identityLine.line(item.line, 24, false);
                    } else {
                        body = '<span class="tw-truncate">' + esc(payload.label) + '</span>' +
                            (group === 'people' && item.location_tx ? '<span class="tw-text-tertiary tw-truncate">' + esc(item.location_tx) + '</span>' : '');
                    }
                    html += '<button type="button" role="option" id="' + uid + '-opt-' + payloads.length + '" aria-selected="false"' +
                        ' class="btn-unstyled tw-flex tw-items-center tw-gap-2 tw-w-full tw-text-start tw-px-2 tw-py-1.5 hover:tw-bg-brand-50 tw-rounded-[8px]"' +
                        ' data-idx="' + payloads.length + '">' +
                        (group === 'people' && item.line ? '' : group === 'people' && item.thumbnail
                            ? '<img src="' + esc(item.thumbnail) + '" alt="" class="tw-h-6 tw-w-6 tw-rounded-full tw-flex-shrink-0">'
                            : '<iconify-icon icon="' + icon + '" class="tw-text-base tw-text-tertiary tw-flex-shrink-0" aria-hidden="true"></iconify-icon>') +
                        body + '</button>';
                    payloads.push(payload);
                });
            });
            if (!html) { hide(); return; }
            panel.innerHTML = html;
            panel.classList.remove('tw-hidden');
            active = -1;
            input.setAttribute('aria-expanded', 'true');
            input.removeAttribute('aria-activedescendant');
        }

        var fetchSuggestions = debounce(function () {
            var term = input.value.trim();
            if (term.length < 2) { hide(); return; }
            var lang = document.documentElement.lang || 'en';
            fetch('/a/suggest2?term=' + encodeURIComponent(term) + '&lang=' + encodeURIComponent(lang))
                .then(function (r) { return r.json(); })
                .then(function (data) { if (input.value.trim() === term) render(data); })
                .catch(hide);
        }, 250);

        input.addEventListener('input', fetchSuggestions);
        input.addEventListener('keydown', function (e) {
            var open = !panel.classList.contains('tw-hidden');
            if (e.key === 'ArrowDown') {
                e.preventDefault();
                if (open) setActive(active + 1); else fetchSuggestions();
            } else if (e.key === 'ArrowUp') {
                if (open) { e.preventDefault(); setActive(active - 1); }
            } else if (e.key === 'Enter') {
                e.preventDefault();
                var opts = options();
                if (open && active > -1 && opts[active] && payloads[+opts[active].dataset.idx]) {
                    emit(payloads[+opts[active].dataset.idx]);
                } else {
                    submitTerm();
                }
            } else if (e.key === 'Escape') {
                if (open) { e.preventDefault(); hide(); }
            }
        });
        if (submit) submit.addEventListener('click', submitTerm);
        panel.addEventListener('mousemove', function (e) {
            var btn = e.target.closest('[role="option"]');
            if (!btn) return;
            var opts = options();
            for (var i = 0; i < opts.length; i++) { if (opts[i] === btn) { setActive(i); break; } }
        });
        panel.addEventListener('click', function (e) {
            var btn = e.target.closest('[role="option"]');
            if (btn && payloads[+btn.dataset.idx]) emit(payloads[+btn.dataset.idx]);
        });
        document.addEventListener('click', function (e) {
            if (!root.contains(e.target)) hide();
        });
    }

    window.JN.omnibox = {init: init};
    document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('[data-omnibox]').forEach(init);
    });
})();
